import {
  Box,
  Button,
  Container,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledForm = styled("form")(() => ({
  height: "100%",
  display: "grid",
  alignContent: "space-between",
}));

export const SidePadding = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

export const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(8),
}));

export const StyledHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
}));

export const BackButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: "50%",
  transform: "translate(-100%, -50%)",
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "initial",
  },
}));

export const StickyFooter = styled(Paper)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: 0,
  zIndex: 1,
  padding: theme.spacing(0, 5),
}));

export const FooterContent = styled(Container)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  "& button": {
    whiteSpace: "nowrap",
  },
}));

export const SubmitArea = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const SubmitError = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));
